import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.black2};
`;

export const InfoWrapper = styled.div`
  display: flex;
  max-width: 300px;
  align-self: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 90px;
  height: 90px;
  padding: 18px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  font-size: 54px;
`;

export const TextWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
  width: 100%;
  text-align: center;
`;
